import { Piece } from 'features/board/board'

export type HexId = (typeof allowedHexIds)[number]
export type HexPiece = null | 'wall' | Piece
export type HexBoard = {
  [key in HexId]: HexPiece
}

export const allowedHexIds = [
  '-2_0',
  '-2_1',
  '-2_2',
  '-2_3',
  '-1_-1',
  '-1_0',
  '-1_1',
  '-1_2',
  '-1_3',
  '0_-2',
  '0_-1',
  '0_0',
  '0_1',
  '0_2',
  '0_3',
  '1_-3',
  '1_-2',
  '1_-1',
  '1_0',
  '1_1',
  '1_2',
  '2_-3',
  '2_-2',
  '2_-1',
  '2_0',
  '2_1',
  '3_-3',
  '3_-2',
  '3_-1',
  '3_0',
] as const

export const initialHexBoard = allowedHexIds.reduce((acc, pos) => {
  acc[pos] = null
  return acc
}, {} as HexBoard)
